import React from 'react';
import { Input, Form } from 'antd';

const { TextArea } = Input;

// https://ant.design/components/form/#components-form-demo-basic
const FormTextArea = ({ label, name, rules, itemProps, extra, ...rest }) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      extra={extra}
      {...(itemProps || {})}
    >
      <TextArea {...rest} />
    </Form.Item>
  );
};

export default FormTextArea;
